import React from "react"

import {hasProperty, formatText} from '../utils/utils';

import dsd from '../classes/clsDSD';

import * as PD from '../classes/pdStyle';

class ViewMethod extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            noLinks: false,
        };


        this.dsd = new dsd();

        this.data = {};
        this.data.Method = null;

        if (this.props.Method){
            this.data.Method = this.props.Method; 
        }

        if (this.props.noLinks){
            this.state.noLinks = this.props.noLinks;
        }

        this.filters = {};

        this.columns = {
        };

        this.data.id = null;
        if (this.props.id){
            this.data.id = this.props.id; 
        }


    }

    componentDidMount() {

        if (this.data.Method){
            this.setState({"isLoaded":true});
            return;
        }

    };

    view(json){

        if (json){
            return(
                <PD.Table className="panel">
                    <PD.Tbody>                                

                        {hasProperty(json,'name') &&
                            <PD.Tr>                                
                                <PD.Th>Name</PD.Th>
                                <PD.Td>
                                    {(() => {
                                        switch (this.state.noLinks) {
                                            case true:
                                                return json.name
                                            default:
                                                return (
                                                    <PD.PdNavLink to={"/method/" + json._id} >
                                                        {json.name}
                                                    </PD.PdNavLink>
                                                )
                                        }
                                    })()}
                                </PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json,'description') &&
                            <PD.Tr>
                                <PD.Th>Description</PD.Th><PD.Td>
                                    <PD.MdPresent>
                                        {json.description}
                                    </PD.MdPresent>
                                </PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json,'proposals') &&
                            <PD.Tr>
                                <PD.Th>Proposals</PD.Th><PD.Td>
                                    <PD.MdPresent>{json.proposals}</PD.MdPresent>
                                </PD.Td>
                            </PD.Tr>
                        }


                        {hasProperty(json,'action') &&
                            <PD.Tr>
                                <PD.Th>Action</PD.Th><PD.Td>{json.action}</PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json,'Serialization') &&
                            <PD.Tr>                                
                                <PD.Th>Request Data Spec</PD.Th>
                                    <PD.Td>    
                                        <PD.PdNavLink to={"/serialization/" + json.Serialization._id} > {json.Serialization.name}</PD.PdNavLink>
                                    </PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json,'Path') &&
                            <PD.Tr>
                                <PD.Th>Path</PD.Th><PD.Td>
                                    {
                                        json.Path.map(
                                            (PathElement, pos) => 
                                                {
                                                    return(
                                                        <span key={pos}>
                                                            /
                                                            {(() => {
                                                                switch (PathElement.type) {
                                                                    case 'string':
                                                                        return PathElement.string
                                                                    case 'parameter':
                                                                        if (PathElement.Parameter){
                                                                            return (
                                                                                <>
                                                                                    {`{`}
                                                                                    <PD.PdNavLink to={"/parameter/" + PathElement.Parameter._id} >
                                                                                        {PathElement.Parameter.name}
                                                                                    </PD.PdNavLink>
                                                                                    {`}`}
                                                                                </>
                                                                            )
                                                                        }
                                                                        return `{${PathElement.idParameter}}`
                                                                }
                                                            })()}                                                            
                                                        </span>
                                                    )
                                                }
                                        )
                                    }

                                </PD.Td>
                            </PD.Tr>
                        }


{/*
                        {hasProperty(json,'Interface') &&
                            <>
                                <PD.Tr>                                
                                    <PD.Th>Interface</PD.Th>
                                    <PD.Td>    
                                        <PD.PdNavLink to={"/interface/" + json.Interface._id} > {json.Interface.name}</PD.PdNavLink>
                                    </PD.Td>
                                </PD.Tr>

                                {json.Interface.Owner &&
                                    <PD.Tr>
                                        <PD.Th>Owner</PD.Th><PD.Td>{json.Interface.Owner.organisation}</PD.Td>
                                    </PD.Tr>
                                }
                            </>

                        }
*/}

                    </PD.Tbody>
                </PD.Table>
            )
        };
        return null;
    };

    render() {

        if (this.state.isLoaded) {

            return (
                <div>
                    {this.view(this.data.Method)}
                </div>
            )
        }
        else {
            return <div />;
        }

    };    
};
        
export default ViewMethod;